import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import TopLoader from "../components/Loader/TopLoader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getstudentinfo } from "../api/Users";
import { TextField, TablePagination } from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ViewExamMarks = ({ userData }) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const rowData = location.state;
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [examMarks, setExamMarks] = useState({
    academic_year: "",
    class: "",
    section_name: "",
    student_name: "",
    exam_name: "",
  });
  const [error, setErrors] = useState({});
  useEffect(() => {
    if (rowData) {
      setExamMarks((prevExamMarks) => ({
        ...prevExamMarks,
        ...rowData,
      }));
    }
    const getStudentDetails = () => {
      setIsLoading(true);
      let data = {
        school_id: userData.data.school_id,
      };
      getstudentinfo(data).then((res) => {
        if (res.status === "success") {
          console.log(res);
          setFilteredData(res.data.student_data);
        } else {
          setRows([]);
          toast.error(t("Something went wrong"));
        }
        setIsLoading(false);
      });
    };
    getStudentDetails();
  }, [rowData, userData.data.school_id, t]);

  const navigate = useNavigate();

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setExamMarks((examMarks) => ({
      ...examMarks,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const formErrors = {};

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      const formData = new FormData();

      // Append each field and its value to the FormData object
      for (const key in examMarks) {
        formData.append(key, examMarks[key]);
      }
    }
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const exportPDF = () => {
    const doc = new jsPDF("landscape", "pt", "letter");

    const title = userData.data.school_name;
    const reportName = "Marksheet";
    const tableColumn = [
      "Roll no.",
      "Student Name",
      "Class",
      "English",
      "Hindi",
      "Maths",
      "Science",
      "Total Marks obtained",
      "Total Marks",
      "Grade",
    ];
    const tableRows = [];

    // Load your logo (replace 'path/to/your/logo.png' with actual path or base64 string)
    const logoUrl = pdfLogo; // Change this URL or use base64 image data
    doc.addImage(logoUrl, "PNG", 10, 10, 30, 30); // Adjust dimensions as needed

    // Calculate the center position for the title vertically with respect to the logo
    const titleHeight = 10 + 15; // Adjust this depending on your logo's height + some margin
    const titleRepHeight = 10 + 50;
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const fromLeft = 330; // Adjust depending on the size and placement of your logo
    const fromRepLeft = 40;

    filteredData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.student_name,
        row.class,
        row.english_marks || 80,
        row.hindi_marks || 75,
        row.maths_marks || 90,
        row.science_marks || 85,
        (parseInt(row.english_marks || 80) +
          parseInt(row.hindi_marks || 75) +
          parseInt(row.maths_marks || 90) +
          parseInt(row.science_marks || 85)),
        row.total_mark_ || 400,
        (getGrade(
          parseInt(row.english_marks || 80) +
          parseInt(row.hindi_marks || 75) +
          parseInt(row.maths_marks || 90) +
          parseInt(row.science_marks || 85)
        )),
      ];
      tableRows.push(rowData);
    });

    doc.setFontSize(16); // Sets the font size to 16 points for the title
    doc.text(title, fromLeft, titleHeight); // Position the title next to the logo
    doc.setFontSize(12);
    doc.text(reportName, fromRepLeft, titleRepHeight);
    doc.setFontSize(12); // Resets the font size for the table
    doc.autoTable(tableColumn, tableRows, { startY: 70 }); // Start the table 100px below the logo and title
    doc.save("Exam Marks.pdf");
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Exam Marks");

    // Add title
    worksheet.mergeCells("A1:G1");
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(1).value = "Exam Marks";
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center" };

    // Add headers
    const headers = [
      "Roll no.",
      "Student Name",
      "Class",
      "English",
      "Hindi",
      "Maths",
      "Science",
      "Total Marks obtained",
      "Total Marks",
      "Grade",
    ];
    // worksheet.addRow([]); // Add empty row for spacing
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" }, // Blue background color
      };
      cell.font = {
        color: { argb: "FFFFFF" }, // White text color
        bold: true,
      };
    });
    // Add data
    filteredData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.student_name,
        row.class,
        row.english_marks || 80,
        row.hindi_marks || 75,
        row.maths_marks || 90,
        row.science_marks || 85,
        (parseInt(row.english_marks || 80) +
          parseInt(row.hindi_marks || 75) +
          parseInt(row.maths_marks || 90) +
          parseInt(row.science_marks || 85)),
        row.total_mark_ || 400,
        (getGrade(
          parseInt(row.english_marks || 80) +
          parseInt(row.hindi_marks || 75) +
          parseInt(row.maths_marks || 90) +
          parseInt(row.science_marks || 85)
        )),
      ]);
    });

    // Set workbook properties
    workbook.creator = "Your Name";
    workbook.lastModifiedBy = "Your Name";
    workbook.created = new Date();
    workbook.modified = new Date();

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = "Exam_Marks.xlsx";
      saveAs(blob, fileName);
    });
  };
  const getGrade = (obt) => {
    const totalMarks = obt/400 * 100;

    if (totalMarks >= 90) {
      return 'A+';
    } else if (totalMarks >= 80) {
      return 'A';
    } else if (totalMarks >= 70) {
      return 'B';
    } else if (totalMarks >= 60) {
      return 'C';
    } else if (totalMarks >= 50) {
      return 'D';
    } else {
      return 'F';
    }
  };
  return (
    <>
      <div className="px-2 px-md-4">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("View Exam Marks")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {t("Academic year")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="academic_year"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select session</option>
                <option value="2022-2024">2022-2024</option>
              </select>
              {error.academic_year && (
                <div className="text-danger">{error.academic_year}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Class")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="class"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select class</option>
                <option value="12">XII</option>
                <option value="11">XI</option>
                <option value="10">X</option>
                <option value="09">IX</option>
                <option value="08">VIII</option>
                <option value="07">VII</option>
                <option value="06">VI</option>
                <option value="05">V</option>
                <option value="04">IV</option>
                <option value="03">III</option>
                <option value="02">II</option>
                <option value="01">I</option>
              </select>
              {error.class && <div className="text-danger">{error.class}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Section Name")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="section_name"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select Section</option>
                <option value="A">Section A</option>
              </select>
              {error.section_name && (
                <div className="text-danger">{error.section_name}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Student Name")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="student_name"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select Student</option>
                <option value="">vikas</option>
              </select>
              {error.student_name && (
                <div className="text-danger">{error.student_name}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Exam Name")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="exam_name"
                onChange={handleChangeInput}
                className="common-input form-select"
                // required
              >
                <option value="">Select Exam</option>
                <option value="Half Yearly">Half Yearly</option>
              </select>
              {error.exam_name && (
                <div className="text-danger">{error.exam_name}</div>
              )}
            </div>
          </div>

          <div className="row col-6 mt-5 d-flex justify-content-start">
            <button type="submit" className="btn btn-primary me-2 col-md-2">
              {t("Search")}
            </button>
            <button
              type="submit"
              className="btn btn-primary me-2 col-md-2"
              variant="contained"
              onClick={exportPDF}
            >
              {t("PDF")}
            </button>
            <button
              type="submit"
              className="btn btn-success me-2 col-md-2"
              onClick={exportExcel}
            >
              {t("Excel")}
            </button>

            <button
              type="reset"
              className="btn btn-secondary me-2 col-md-2"
            >
              {t("Reset")}
            </button>
          </div>
        </form>
      </div>

      <div className="row col-12 d-flex justify-content-center mt-4 bg-white"></div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Exam marks")}</h5>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Roll No.")}</TableCell>
                  <TableCell align="center">{t("Student Name")}</TableCell>
                  <TableCell align="center">{t("Class")}</TableCell>
                  <TableCell align="center">{t("English")}</TableCell>
                  <TableCell align="center">{t("Hindi")}</TableCell>
                  <TableCell align="center">{t("Maths")}</TableCell>
                  <TableCell align="center">{t("Science")}</TableCell>
                  <TableCell align="center">
                    {t("Total Marks obtained")}
                  </TableCell>
                  <TableCell align="center">{t("Total Marks")}</TableCell>
                  <TableCell align="center">{t("Grade")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ width: "6rem" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.student_name || "Vikas"}
                        </TableCell>
                        <TableCell align="center" style={{ width: "5%" }}>
                          {row.class || "X"}
                        </TableCell>
                        <TableCell align="center">
                          {row.english_marks || 80}
                        </TableCell>
                        <TableCell align="center">
                          {row.hindi_marks || 10}
                        </TableCell>
                        <TableCell align="center">
                          {row.maths_marks || 20}
                        </TableCell>
                        <TableCell align="center">
                          {row.science_marks || 85}
                        </TableCell>
                        <TableCell align="center">
                          {parseInt(row.english_marks || 70) +
                            parseInt(row.hindi_marks || 80) +
                            parseInt(row.maths_marks || 10) +
                            parseInt(row.science_marks || 85)}
                        </TableCell>
                        <TableCell align="center">
                          {row.total_mark_ || 400}
                        </TableCell>
                        <TableCell align="center">
                          {getGrade(
                            parseInt(row.english_marks || 10) +
                            parseInt(row.hindi_marks || 8) +
                            parseInt(row.maths_marks || 90) +
                            parseInt(row.science_marks || 9)
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      ></TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default ViewExamMarks;
